<div class="settings-modal-content">
  <h2 class="mat-h2">Bricks</h2>
  <div class="flex gap-4 items-center">
    <mat-form-field appearance="fill" class="w-1/2">
      <mat-label>Select Region</mat-label>
      <mat-select [(value)]="selectedRegionId" (selectionChange)="onRegionChange()">
        <mat-option *ngFor="let region of regions" [value]="region.id">{{ region.name }}</mat-option>
      </mat-select>
    </mat-form-field>
    <div class="text-sm flex items-center gap-4">
      <button type="button" mat-flat-button color="accent" (click)="fileInput1.click()">Import bricks sales</button>
      <input hidden (change)="importBricks($event, 'sales')" #fileInput1 type="file" id="file" />
    </div>

    <div class="text-sm flex items-center gap-4">
      <button type="button" mat-flat-button color="accent" (click)="fileInput2.click()">Import bricks patients</button>
      <input hidden (change)="importBricks($event, 'patients')" #fileInput2 type="file" id="file" />
    </div>

    <div class="text-sm flex items-center gap-4">
      <button type="button" mat-flat-button color="accent" (click)="fileInput3.click()">Import sales in €</button>
      <input hidden (change)="importBricks($event, 'salesInEuro')" #fileInput3 type="file" id="file" />
    </div>
  </div>

  <div *ngIf="selectedRegionId" class="mt-4">
    <h3 class="text-lg mt-4 mb-2">Add New Brick</h3>
    <div class="flex gap-4">
      <mat-form-field appearance="fill">
        <mat-label>Name</mat-label>
        <input matInput [(ngModel)]="newBrickData.name" required />
      </mat-form-field>
      <mat-form-field appearance="fill">
        <mat-label>ID</mat-label>
        <input matInput [(ngModel)]="newBrickData.id" required />
      </mat-form-field>
      <button mat-flat-button color="primary" (click)="addBrick()" [disabled]="!isValid()"><span>Add Brick</span></button>
    </div>

    <!-- Brick List -->
    <h3 class="text-lg mt-4 mb-2">Bricks in Region</h3>
    <div *ngIf="filteredBricks.length; else noBricks" class="pb-4">
      <div *ngFor="let brick of filteredBricks; let i = index" class="border border-gray-300 rounded-lg p-4 mb-4">
        <div class="flex gap-4 items-center">
          <mat-form-field appearance="fill">
            <mat-label>Name</mat-label>
            <input matInput [(ngModel)]="brick.name" required />
          </mat-form-field>
          <mat-form-field appearance="fill">
            <mat-label>ID</mat-label>
            <input matInput [(ngModel)]="brick.id" required />
          </mat-form-field>
          <button mat-icon-button (click)="deleteBrick(brick)" aria-label="Delete" color="error"><mat-icon>delete_forever</mat-icon></button>
        </div>
        <mat-expansion-panel class="mb-2" hideToggle (opened)="panelOpenState[i] = true" (closed)="panelOpenState[i] = false">
          <mat-expansion-panel-header>
            <mat-panel-title class="p-2">{{ panelOpenState[i] ? "hide" : "show" }} sales data <mat-icon *ngIf="!panelOpenState[i]">keyboard_arrow_down</mat-icon> <mat-icon *ngIf="panelOpenState[i]">keyboard_arrow_up</mat-icon></mat-panel-title>
          </mat-expansion-panel-header>
          <div class="px-2">momentum (short: {{ formatMomentum(brick.salesMomentumShort) }}, long: {{ formatMomentum(brick.salesMomentumLong) }})</div>
          <div *ngIf="panelOpenState[i]" class="px-2">
            <h3 class="text-md font-medium mt-2">Add New Month</h3>
            <div class="grid grid-cols-2 md:grid-cols-6 gap-4">

              <mat-form-field appearance="fill">
                <mat-label>Year</mat-label>
                <input matInput [(ngModel)]="newSale.year" required />
              </mat-form-field>
              <mat-form-field appearance="fill">
                <mat-label>Month</mat-label>
                <input matInput [(ngModel)]="newSale.month" required />
              </mat-form-field>
              <mat-form-field appearance="fill">
                <mat-label>Packs</mat-label>
                <input matInput [(ngModel)]="newSale.sales" required />
              </mat-form-field>
              <mat-form-field appearance="fill">
                <mat-label>Patients</mat-label>
                <input matInput [(ngModel)]="newSale.patients" required />
              </mat-form-field>
              <mat-form-field appearance="fill">
                <mat-label>Sales in €</mat-label>
                <input matInput [(ngModel)]="newSale.salesInEuro" required />
              </mat-form-field>

              <button mat-flat-button color="primary" (click)="addSale(brick)" [disabled]="!isSaleValid(brick)"><span>Add month</span></button>
            </div>
            <h4 class="mat-h4">Sales</h4>
            <div *ngFor="let sale of sortSales(brick); let iSale = index;">
              <div class="grid grid-cols-2 md:grid-cols-6 gap-4">

                <mat-form-field appearance="fill">
                  <mat-label>Year</mat-label>
                  <input matInput [(ngModel)]="sale.year" required />
                </mat-form-field>
                <mat-form-field appearance="fill">
                  <mat-label>Month</mat-label>
                  <input matInput [(ngModel)]="sale.month" required />
                </mat-form-field>
                <mat-form-field appearance="fill">
                  <mat-label>Packs</mat-label>
                  <input matInput [(ngModel)]="sale.sales" required type="number" (ngModelChange)="onSalesChange(sale.sales, brick)"/>
                </mat-form-field>
                <mat-form-field appearance="fill">
                  <mat-label>Patients</mat-label>
                  <input matInput [(ngModel)]="sale.patients" required type="number" />
                </mat-form-field>
                <mat-form-field appearance="fill">
                  <mat-label>Sales in €</mat-label>
                  <input matInput [(ngModel)]="sale.salesInEuro" required type="number" />
                </mat-form-field>

                <button mat-icon-button (click)="deleteSale(brick, sale)" aria-label="Delete" color="error">
                  <mat-icon>delete_forever</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      </div>
    </div>
    <ng-template #noBricks>
      <p>No bricks in this region yet.</p>
    </ng-template>
  </div>
</div>
